module.exports = __webpack_public_path__ + "static/media/nzl.2f81d400.svg";